import React,{ Component } from "react";
import { Tree,message,Input, Button, Empty, Space } from 'antd';
import { GetPermsList,GetPermByRoleId,BindPermsByRoleId} from "../../model/permission/requests";
import BreadcrumbCustomer from "../breadcrumb";
import storage from '../../utils/storage';
import { configs } from '../../config/config';
import { addKey } from "../../utils/utils";
import { route } from "../../routes/routes";

const { Search } = Input;
const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key;
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children);
        }
      }
    }
    return parentKey;
  };




export default class BindPerm extends Component {
    constructor(props){
        super(props)
        this.state = {
            permList:[],
            selectedPerm:[],
            expandedKeys:[],
            setAutoExpandParent:false,
            newPermIds:[],
            isButton:true
        }
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    componentDidMount(){
        // load the permisson of the role
        let _id = this.props.match.params.id;
        let selectedPerm = []
        GetPermByRoleId({id:_id}).then(res=>{
            if(res.data.code === 200 ){
                selectedPerm = res.data.data
                console.log(selectedPerm)
                this.setState({
                    selectedPerm:selectedPerm
                })
            }else{
                message.warn(res.data.msg)

            }
        }).catch(err=>{
            message.error(err)
        })


        let permList = []
        GetPermsList().then(res=>{
            if (res.data.code === 200) {
                permList = addKey(res.data.data)
                console.log(permList)
                this.setState({
                    permList:permList
                })
            }else{
                message.warn(res.data.msg);
            }
        }).catch(err=>{
            message.error(err)
        })

    }

    handleCheck = (checkedKeysValue) =>{
        this.setState({
            isButton:false,
            newPermIds:checkedKeysValue
        })
    }

    handleChange = (e) => {
        let defaultData = []
        let   value = e.target.value
        const newExpandedKeys = this.state.permList.map(item=>{
            if (item.title.indexOf(value) > -1) {
                return getParentKey(item.key, this.state.permList);
              }
              return null;
        }).filter((item, i, self) => item && self.indexOf(item) === i)

    }

    onExpand = (newExpandedKeys) => {
        this.setState({
            expandedKeys:newExpandedKeys,
            setAutoExpandParent:false
        })
    
      };

    handleClick = () => {
        let role_id = parseInt(this.props.match.params.id)
        let permIds = this.state.newPermIds

        if(permIds.length <= 0){
            message.error("you can't missed the permissions")
            return false
        }

       let perms_id = permIds.join(",")
        BindPermsByRoleId({role_id:role_id,perms_id:perms_id}).then(res=>{
            if (res.data.code === 200) {
                message.success("Bind permission Ok")
                setTimeout(()=>{
                    this.props.history.push(route.role.index)
                },1000)
            }else{
                message.warn(res.data.msg);
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handleSelect = (selectedKeys,e)=>{
        this.setState({
            newPermIds:selectedKeys
        })
    }
    

    render(){
        const {permList} = this.state;
        return (
            <>
                <BreadcrumbCustomer   first='Role' second='Perm' />
                { this.state.permList.length ? (
                    <>
                {/* <Search
                          style={{
                            marginBottom: 8,
                          }}
                    placeholder="Search"
                    onChange={this.handleChange}
                /> */}
                 <Tree 
                    defaultExpandAll = {true}
                    defaultCheckedKeys = {this.state.selectedPerm.length ? (this.state.selectedPerm) : ([])}
                    treeData={permList} 
                    checkable
                    onCheck = {this.handleCheck}
                    onSelect = {this.handleSelect}
                    showLine
                  //  blockNode
                /> 
                </>) : (
                    "loading data"
                )
                }
                <Space />
                <Button 
                disabled = {this.state.isButton}
                style={{background: "#851dd6",color:"white" }}
                onClick={this.handleClick}>BindPerms</Button>
            </>
        )
    }
}